autosize($('.js-auto-size'));


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/autosize-init.js